var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBloqueoDePuerta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#a03232;}.cls-3{fill:#040006;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-bloqueo-de-puerta") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_20_copia_2",
    "data-name": "20 copia 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.3,
    cy: 114.11,
    r: 105.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125.39,113.41c0-7-.08-13.85,0-20.67a17.4,17.4,0,0,1,34.8.11c.08,5.91,0,11.82,0,17.73v2.53c.36.23.42.3.49.31,7.23.74,7.6,1.15,7.6,8.54,0,6.84,0,13.68,0,20.52,0,4.14-1.72,5.85-5.85,5.86H122.94c-4.46,0-6.07-1.65-6.08-6.16q0-11,0-22c0-5.16,1.38-6.53,6.63-6.62C124,113.51,124.5,113.47,125.39,113.41Zm8.28,0h18.19c0-6.87,0-13.6,0-20.32a9.06,9.06,0,1,0-18.12-.25c-.17,4.55,0,9.12-.06,13.68ZM140,130.93c0,1.51-.32,3.11.1,4.49.32,1,1.58,2.45,2.46,2.47a3.5,3.5,0,0,0,2.57-2.3,44.29,44.29,0,0,0,0-9.28,3.49,3.49,0,0,0-2.55-2.29c-.88,0-2.16,1.39-2.48,2.41C139.64,127.81,140,129.42,140,130.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M169.62,173.23h-14.2V157.36a2.4,2.4,0,1,0-4.8,0v15.78H140.49a3,3,0,0,0-.43,0V157.36a2.4,2.4,0,0,0-4.8,0v15.78H79.12V57.52l56.14-9.36v18.9a2.4,2.4,0,1,0,4.8,0v-10a2,2,0,0,0,.43,0h10.13V67.31a2.4,2.4,0,1,0,4.8,0V54.74a2.39,2.39,0,0,0-2.4-2.4H140.49a2,2,0,0,0-.43,0V45.33a2.41,2.41,0,0,0-.85-1.84,2.39,2.39,0,0,0-1.94-.53l-61,10.15a2.41,2.41,0,0,0-2,2.37V173.23H59.63a2.4,2.4,0,1,0,0,4.8h110a2.4,2.4,0,0,0,0-4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBloqueoDePuerta);
export default __webpack_public_path__ + "static/media/ic-bloqueo-de-puerta.66ef83c019baa27bc0ef585aef10876c.svg";
export { ForwardRef as ReactComponent };